// Lightweight logger — no-ops in production, forwards to console in dev.
// Use this instead of raw `console.*` calls so we don't leak debug info in prod.
const isDev = process.env.NODE_ENV !== 'production';

export const logger = {
  log: (...args) => { if (isDev) console.log(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  error: (...args) => { if (isDev) console.error(...args); },
  debug: (...args) => { if (isDev) console.debug(...args); },
};

export default logger;
